export const MENSAGEM_ERRO_DEFAULT =
  'Ocorreu algum erro interno. Tente novamente mais tarde';
